import React from "react";
import "./Footer.css";

const Footer = () => (
  <footer className="footer">
    <div className="footer-top">
      <div className="container footer-grid">
        <div className="footer-brand">
          <div className="footer-logo"><span></span> Business Idea Hub</div>
          <p>Your complete guide to top 50 online business ideas. Learn proven strategies, business models, and step-by-step guidance to start your entrepreneurial journey in India.</p>
          <div className="footer-social">
            <a href="/social/facebook" aria-label="Facebook" className="social-icon"></a>
            <a href="/social/instagram" aria-label="Instagram" className="social-icon"></a>
            <a href="/social/twitter" aria-label="Twitter" className="social-icon"></a>
            <a href="/social/youtube" aria-label="YouTube" className="social-icon"></a>
          </div>
        </div>

        <div className="footer-links-col">
          <h4>E-Book</h4>
          <ul>
            <li><a href="#ebook">Get Complete E-Book</a></li>
            <li><a href="#business-ideas">Business Ideas</a></li>
            <li><a href="#resources">Resources</a></li>
            <li><a href="#testimonials">Success Stories</a></li>
            <li><a href="#pricing">Pricing</a></li>
          </ul>
        </div>

        <div className="footer-links-col">
          <h4>Support</h4>
          <ul>
            <li><a href="/downloads">Download Instructions</a></li>
            <li><a href="/faq">FAQs</a></li>
            <li><a href="/refund-policy">Refund Policy</a></li>
            <li><a href="/delivery-info">Delivery Information</a></li>
            <li><a href="#contact">Contact Us</a></li>
          </ul>
        </div>

        <div className="footer-links-col">
          <h4>Company</h4>
          <ul>
            <li><a href="/about">About Us</a></li>
            <li><a href="/blog">Blog</a></li>
            <li><a href="/affiliate">Affiliate Program</a></li>
            <li><a href="/bulk-orders">Bulk Orders</a></li>
            <li><a href="/media-kit">Media Kit</a></li>
          </ul>
        </div>

        <div className="footer-links-col">
          <h4>Contact</h4>
          <div className="footer-contact-info">
            <p> <a href="tel:+917754929443">+91 775 492 9443</a></p>
            <p> <a href="mailto:chitrarthgaurav@gmail.com">chitrarthgaurav@gmail.com</a></p>
            <p> Mon–Fri, 9AM–6PM IST</p>
          </div>
          <div className="footer-payment">
            <h5>We Accept</h5>
            <div className="payment-icons">
              <span></span><span></span><span></span><span></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="footer-bottom">
      <div className="container footer-bottom-inner">
        <p>© 2026 Business Idea Hub. All rights reserved.</p>
        <div className="footer-legal">
          <a href="/privacy-policy">Privacy Policy</a>
          <a href="/terms-of-service">Terms of Service</a>
          <a href="/cookie-policy">Cookie Policy</a>
          <a href="/index.html?admin=1" className="admin-link">Admin</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
